import { type ApiResponse } from '@/types/api'
import type {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'

export const logOnRequestSuccess = async (
  config: InternalAxiosRequestConfig,
) => {
  console.log('请求发送：', {
    method: config.method?.toUpperCase(),
    url: config.url,
    data: config.data,
    params: config.params,
    token: config.headers?.Authorization,
    headers: config.headers,
  })
  return config
}
export const logOnRequestError: (error: Error) => any = (error) => {
  console.error('请求配置错误：', {
    message:error.message,
    stack:error.stack,
    name:error.name,
    cause:error.cause
  })
}
export const logOnResponseSuccess = (response: AxiosResponse<ApiResponse>) => {
  console.log('响应接收：', {
    code: response.data?.code,
    msg: response.data?.msg,
    data: response.data?.data,
    url: response.config?.url,
    more: {
      status: response.status,
      headers: response.headers,
      params: response.config?.params,
      config: response.config,
    },
  })
  return response.data
}
export const logOnResponseError = (error: AxiosError) => {
  console.error('请求失败：', JSON.stringify(error))
}
